import { SxProps, Theme } from '@mui/material/styles'
import { hoverBaseStyles } from '../base/hoverBase.styles'

export const birthdayStyles = {
  root: {
    ...hoverBaseStyles.root,
  } as SxProps<Theme>,

  message: {
    color: 'info.main',
    ...hoverBaseStyles.textRegular,
  } as SxProps<Theme>,
}
